import { ChangeDetectionStrategy, Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import {
  MultiLangDictService,
  USE_MULTI_LANG_DICT
} from 'projects/ppb-shared-library/src/lib/services/multi-lang-dict.service';
import { DictionaryModel } from '../../shared/models/dictionary.model';
import { DictionaryService } from '../../../../../projects/ppb-shared-library/src/lib/services/dictionary.service';

@Component({
  selector: 'ppb-account-data-form',
  templateUrl: './ppb-account-data-form.component.html',
  styleUrls: ['./ppb-account-data-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PpbAccountDataFormComponent implements OnInit {

  @Input() accountForm: UntypedFormGroup;
  @Input() readonly = true;
  personalData: string = $localize`:@@account.personal_data:Dane osobowe i poziom sprawdzenia tożsamości`;
  phoneNumber: string = $localize`:@@common.phone:Numer telefonu`;

  ialOptions: DictionaryModel[];

  constructor(
    @Optional() @Inject(USE_MULTI_LANG_DICT) private useMultiLangDict: boolean,
    private oldDictionaryService: DictionaryService,
    private dictionaryService: MultiLangDictService,
  ) {
  }

  ngOnInit(): void {
    if (!this.useMultiLangDict) {
      this.ialOptions = this.oldDictionaryService.getSecurityLevels();
    } else {
      this.ialOptions = this.dictionaryService.getSecurityLevels();
    }
  }
}
